import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PlanningSetup from "@/pages/admin/PlanningSetup";
import PlanningSettings from "@/pages/admin/PlanningSettings";
import { DemoPlanning } from "@/components/DemoPlanning";

// Planning V2 activé par entreprise : nouvel assistant ; sinon paramétrage historique. Démo : planning fictif publié en première vue.
export default function PlanningEntry() {
  const [org, setOrg] = useState(null);
  useEffect(() => { api.get("/organization").then((r) => setOrg(r.data)).catch(() => setOrg({})); }, []);
  if (org === null) return null;
  if (org.is_demo && org.planning_v2_enabled) return <DemoPlanning />;
  return org.planning_v2_enabled ? <PlanningSetup /> : <PlanningSettings />;
}
